import {
  FETCH_BUSINESS_FUNCTIONS_REQUEST,
  FETCH_ASSET_GROUPS_REQUEST,
} from "../types/business_functions";

const initialState = {
  businessFunctions: [],
  assetGroups: [],
};

const businessFunctionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BUSINESS_FUNCTIONS_REQUEST:
      return { ...state, businessFunctions: action.payload };
    // Add other cases for success and failure if needed
    case FETCH_ASSET_GROUPS_REQUEST:
      return { ...state, assetGroups: action.payload };
    default:
      return state;
  }
};

export default businessFunctionsReducer;
